module.exports = __webpack_public_path__ + "img/starr.6c15d31f.png";